var render = function render(){var _vm=this,_c=_vm._self._c;return _c('headroom',[_c('header',{staticClass:"headerbar"},[_c('div',{staticClass:"logo"},[_c('span',[_vm._v("Numbers")]),_c('i',{staticClass:"el-icon-more"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }